module.exports = __webpack_public_path__ + "img/undraw_team_collaboration_8eoc.60130287.svg";